import { Fragment, useState } from 'react';
import {
  Box,
  Grid,
  RadioGroup,
  Radio,
  Typography,
  FormHelperText,
} from '@mui/material';
import { StyledFormControlLabel } from 'routes/Main/style';
import GridItem from '../../components/GridItem';
import SectionTitle from '../../components/SectionTitle';
import Form from 'components/Form';

import { Ti18nId } from 'hooks/useI18n';
import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const radioId = ['face', 'legs', 'activity', 'cry', 'consolability'];

const ApgarScore = (props: Props) => {
  const { disabled, getValues, setValue, register, watch } = props;

  const [errors, setErrors] = useState({
    one_min: false,
    five_min: false,
  });

  const [sumValue, setSumValue] = useState(0);
  const onChange = (e: React.ChangeEvent<HTMLInputElement>, v: string) => {
    setValue(e.target.name, e.target.value);
    setSumValue(
      radioId.reduce((acc, cur) => {
        const value = Number(watch(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  return (
    <>
      <SectionTitle title="Điểm APGAR " />
      <Box sx={{ width: '90%', margin: '50px auto' }}>
        <Grid container spacing={1}>
          <GridItem bgColor="#0000001F" text="APGAR" />
          <GridItem bgColor="#0000001F" text="0 điểm" />
          <GridItem bgColor="#0000001F" text="1 điểm" />
          <GridItem bgColor="#0000001F" text="2 điểm" />

          <GridItem bgColor="#0000001F" text="Đặc điểm ngoại hình" />
          <RadioGroup
            name={'face'}
            row
            sx={{
              width: '75%',
              display: 'flex',
              justifyContent: 'space-around',
            }}
            onChange={onChange}
          >
            <StyledFormControlLabel
              disabled={disabled}
              value={0}
              label={'Xanh xao'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={1}
              label={'Các chi xanh, cơ thể hồng'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={2}
              label={'Hồng hào'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
          </RadioGroup>

          <GridItem bgColor="#0000001F" text="Mạch" />
          <RadioGroup
            name={'legs'}
            row
            sx={{
              width: '75%',
              display: 'flex',
              justifyContent: 'space-around',
            }}
            onChange={onChange}
          >
            <StyledFormControlLabel
              disabled={disabled}
              value={0}
              label={'Không có'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={1}
              label={'<100 BPM'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={2}
              label={'≥100 BPM'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
          </RadioGroup>

          <GridItem bgColor="#0000001F" text="Biểu lộ khuôn mặt" />
          <RadioGroup
            name={'activity'}
            row
            sx={{
              width: '75%',
              display: 'flex',
              justifyContent: 'space-around',
            }}
            onChange={onChange}
          >
            <StyledFormControlLabel
              disabled={disabled}
              value={0}
              label={'Không có'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={1}
              label={'Nhăn mặt'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={2}
              label={'Hắt hơi/ ho'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
          </RadioGroup>

          <GridItem bgColor="#0000001F" text="Hoạt động" />
          <RadioGroup
            name={'cry'}
            row
            sx={{
              width: '75%',
              display: 'flex',
              justifyContent: 'space-around',
            }}
            onChange={onChange}
          >
            <StyledFormControlLabel
              disabled={disabled}
              value={0}
              label={'Mềm oặt'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={1}
              label={'Co nhẹ chi'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={2}
              label={'Hoạt động'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
          </RadioGroup>

          <GridItem bgColor="#0000001F" text="Hô hấp" />
          <RadioGroup
            name={'consolability'}
            row
            sx={{
              width: '75%',
              display: 'flex',
              justifyContent: 'space-around',
            }}
            onChange={onChange}
          >
            <StyledFormControlLabel
              disabled={disabled}
              value={0}
              label={'Không hô hấp'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={1}
              label={'Khó khăn/ chậm'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
            <StyledFormControlLabel
              disabled={disabled}
              value={2}
              label={'Tốt/ khóc'}
              control={
                <Radio
                  sx={{
                    '&.Mui-checked': {
                      color: '#2D73DC',
                    },
                  }}
                />
              }
            />
          </RadioGroup>
        </Grid>
        <Grid item xs={12}>
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-end'}
            sx={{ marginTop: '20px' }}
          >
            <Typography
              gutterBottom
              minWidth={115}
              fontWeight={700}
              variant="subtitle1"
            >
              Tổng: {sumValue}
            </Typography>
          </Box>
        </Grid>
      </Box>
      <Box
        sx={{
          width: '90%',
          margin: '0px auto',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            width: '40%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography fontSize="14px">1phút</Typography>
          <Box>
            <Form.MuiTextField
              placeholder="0-10 điểm"
              required={false}
              disabled={disabled}
              error={errors.one_min}
              {...register('newborn_condition.apgar_score1m', {
                onChange: e => {
                  if (e.target.value < 0 || e.target.value > 10)
                    setErrors({ ...errors, one_min: true });
                  else setErrors({ ...errors, one_min: false });
                },
              })}
            />
            {errors.one_min ? (
              <FormHelperText error={true}>
                Điểm Apgar nằm trong khoảng từ 1 đến 10
              </FormHelperText>
            ) : null}
          </Box>
          <Typography fontSize="14px">5phút</Typography>
          <Box>
            <Form.MuiTextField
              placeholder="0-10 điểm"
              required={false}
              disabled={disabled}
              error={errors.five_min}
              {...register('newborn_condition.apgar_score5m', {
                onChange: e => {
                  if (e.target.value < 0 || e.target.value > 10)
                    setErrors({ ...errors, five_min: true });
                  else setErrors({ ...errors, five_min: false });
                },
              })}
            />
            {errors.five_min ? (
              <FormHelperText error={true}>
                Điểm Apgar nằm trong khoảng từ 1 đến 10
              </FormHelperText>
            ) : null}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ApgarScore;
